module.exports = __webpack_public_path__ + "img/xpicture.a43bebcd.png";